import React from 'react';
import IframeWrapper from '../iframe-wrapper';
import { H1 } from '../atoms/typography';

const THUMBNAIL_WIDTH = 320;
const THUMBNAIL_HEIGHT = 180;

const YTGalleryPage = ({
  pageTitle,
  videoId,
  videoListId,
  videos = [],
  setVideo
}) => (
  <article className="article">
    <div className="text-center">
      <H1>{pageTitle}</H1>
    </div>

    <div className="my-4 mb-8 text-base text-gray-500">
      <IframeWrapper
        id="yt-video"
        name={`${pageTitle} video player`}
        src={
          videoId
            ? `https://www.youtube.com/embed/${videoId}?&autoplay=1`
            : `https://www.youtube.com/embed/videoseries?list=${videoListId}`
        }
        title="YouTube video player"
      />
    </div>

    <ul className="yt-video-grid grid grid-cols-2 md:grid-cols-3 gap-y-2 gap-x-8 md:gap-x-10 p-0 items-start">
      {videos.map(({ videoId: id, title, thumbnailUrl }) => (
        <li
          key={id}
          role="button"
          tabIndex={0}
          className="group rounded p-2 min-h-full border-solid hover:border-2 border-blue-500 border-opacity-20 hover:shadow-lg card list-none cursor-pointer hover:opacity-80"
          onClick={() => setVideo(id)}
          onKeyDown={(event) => {
            if (event.key === 'Enter' || event.key === ' ') {
              event.preventDefault();
              setVideo(id);
            }
          }}
        >
          <p>
            <img
              className="max-w-full"
              width={THUMBNAIL_WIDTH}
              height={THUMBNAIL_HEIGHT}
              src={thumbnailUrl}
              alt={title}
            />
          </p>
          <p className="font-md md:font-lg font-semibold ">{title}</p>
        </li>
      ))}
    </ul>
  </article>
);

export default YTGalleryPage;
